// As per styled-system/theme-ui, each color can either have a single key or shades (usually from 50-900)
// As per styled-system/theme-ui, each color can either have a single key or shades (usually from 50-900)

// https://material.io/design/material-theming/implementing-your-theme.html#color

export default {
  primary: {
    base: '#019013',
    light: '#039b15',
    tint: '#039b15',
    dark: '#019013',
  },

  secondary: {
    base: '#00ACEB',
    light: '#E5FEFF',
    tint: '#0097CE',
    dark: '#0086B8',
  },

  tertiary: {
    base: '#4AFFE2',
    light: '#99FFEE',
    tint: '#00E0BB',
    dark: '#007A66',
  },

  text: {
    base: '#1B2221',
    light: '#5B716E',
    tint: '#364442',
    dark: '#2D3937',
  },

  complimentary: {
    base: '#FDEEB0',
    light: '#FBE074',
    tint: '#FAD338',
    dark: '#EFC006',
  },

  notification: '#0097CE',

  success: '#12805C',

  error: '#C9252D',

  border: {
    base: '#C2CDCC',
    light: '#F5F5F5',
  },

  /**
   * @deprecated
   *
   * These are deprecated colors kept around to not break anything.
   * DO NOT USE THESE MORE!
   */
  // primary: '#ed3d86',
  primaryLight: '#f16aa2',
  primaryDark: '#a8104f',
  primaryButton: '#ea357b',
  // tertiary: '#e5feff',
  focus: '#0097ce',

  inputAddonPrimary: '#fafafa',

  gray: {
    25: '#f4f4f4',
    50: '#f5f5f5',
    100: '#f6f6f6',
    200: '#efefef',
    250: '#f0f2f5',
    300: '#d3d3d3',
    350: '#cccccc',
    400: '#c2cdcc',
    500: '#c9d3d2',
    600: '#99a09f',
    700: '#959595',
    750: '#505050',
    800: '#2c2c2c',
    900: '#1b2221',
  },
  secondaryButton: {
    hover: '#e0e6e5',
    down: '#a2b3b2',
  },
  red: {
    300: '#e34850',
    400: '#d7373f',
    500: '#ff0000',
    600: '#dc2e23',
    700: '#c9252d',
  },
  blue: {
    200: '#00aceb',
    300: '#0097ce',
  },
  yellow: {
    300: '#fdeeb0',
  },
  green: {
    300: '#05c486',
    600: '#318e6c',
  },
  brandPink: '#ed3d86',
  brandPinkLight: '#f16aa2',
  brandPinkDark: '#a8104f',
  brandPinkButton: '#ea357b',
  brandYellow: '#fdeeb0',
  focusBlue: '#0097ce',
};
